<template>
  <BreadCrumb :PageTitle="t('breadCrumb.leadDetails')" />
  <LeadDetails />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import LeadDetails from "../../components/CRM/LeadDetails/LeadDetails.vue";

export default defineComponent({
  name: "LeadDetailsPage",
  components: {
    BreadCrumb,
    LeadDetails,
  },
  setup() {
    const { t } = useI18n();

    return {
      t,
    };
  },
});
</script>